import TemplateApi from "../api/TemplateApi";
import * as types from "../constants/actionConstants";
import {debugLog} from "../utilities/debugLogger";

export function getSystemSetting() {
    return (dispatch) => {
        if (typeof window !== 'undefined') {
            window.__settingsFetchCount = (window.__settingsFetchCount || 0) + 1;
            debugLog('SETTINGS','Fetching /settings attempt #' + window.__settingsFetchCount);
        } else {
            debugLog('SETTINGS','Fetching /settings (no window)');
        }
        const startTs = Date.now();
        TemplateApi.getSettings().then((settings) => {
            const dur = Date.now() - startTs;
            debugLog('SETTINGS',`/settings fetch resolved in ${dur}ms`, settings && settings.status ? {status: settings.status} : undefined);
            dispatch({
                type: types.SET_SYSTEM_SETTING,
                payload: {...settings}
            });
        }).catch(err => {
            const dur = Date.now() - startTs;
            debugLog('SETTINGS',`/settings fetch FAILED in ${dur}ms`, err);
        });
    };
}
